class BenefitsBar extends HTMLElement {
  constructor () {
    super()

    this.currentIndex = 0
    this.touchStartX = 0
    this.touchEndX = 0
    this.benefitsBar = this.querySelector('#wt-benefits-bar__container')
    this.benefitsInterval = null

    this.changeBenefit = this.changeBenefit.bind(this)
    this.previousBenefit = this.previousBenefit.bind(this)
    this.handleTouchStart = this.handleTouchStart.bind(this)
    this.handleTouchMove = this.handleTouchMove.bind(this)
    this.handleTouchEnd = this.handleTouchEnd.bind(this)
    this.hideForOneDay = this.hideForOneDay.bind(this)
    this.restartInterval = this.restartInterval.bind(this)
    this.isMobileView = this.isMobileView.bind(this)
  }

  connectedCallback () {
    this.benefitInterval = setInterval(this.changeBenefit, 5000)
    if (this.benefitsBar) {
      this.benefitsBar.addEventListener(
        'touchstart',
        this.handleTouchStart,
        { passive: true },
      )
      this.benefitsBar.addEventListener(
        'touchmove',
        this.handleTouchMove,
        {
          passive: true,
        },
      )
      this.benefitsBar.addEventListener('touchend', this.handleTouchEnd, {
        passive: true,
      })
      this.benefitsBar.addEventListener(
        'touchstart',
        () => clearInterval(this.benefitInterval),
        { passive: true },
      )
      this.benefitsBar.addEventListener(
        'touchend',
        this.restartInterval,
        {
          passive: true,
        },
      )
      window.addEventListener('resize', this.handleResize.bind(this))
    }
  }

  handleResize () {
    if (window.innerWidth >= 900) {
      // Reset the translateX to its initial state
      if (this.benefitsBar) {
        this.benefitsBar.style.transform = 'translateX(0)'
        this.currentIndex = 0
      }
    }
  }

  isMobileView () {
    return window.innerWidth < 900
  }

  restartInterval () {
    clearInterval(this.benefitInterval)
    this.benefitInterval = setInterval(this.changeBenefit, 5000)
  }

  hideForOneDay () {
    const oneDayLater = new Date().getTime() + 24 * 60 * 60 * 1000
    localStorage.setItem('wt-benefit-hidden', oneDayLater)
    this.style.display = 'none'
  }

  changeBenefit () {
    if (!this.isMobileView()) {
      return
    }

    const totalSlides = this.benefitsBar?.children.length

    // Move to the next slide
    this.currentIndex = (this.currentIndex + 1) % totalSlides
    const newPosition = -(this.currentIndex * 100)

    if (this.benefitsBar)
      this.benefitsBar.style.transform = `translateX(${newPosition}vw)`

    if (this.currentIndex === 0 && this.benefitsBar) {
      // When we're back at the start, reset position with transition.
      setTimeout(() => {
        this.benefitsBar.style.transition = 'none'
        this.benefitsBar.style.transform = 'translateX(0)'
        this.currentIndex = 0
        // Restore transition after resetting position
        setTimeout(() => {
          this.benefitsBar.style.transition = 'transform 0.5s ease-in-out'
        }, 0)
      }, 490) // Just slightly before 0.5s to ensure it happens before next slide movement.
    }
  }

  previousBenefit () {
    const totalSlides = this.benefitsBar?.children.length

    this.currentIndex = (this.currentIndex - 1 + totalSlides) % totalSlides
    const newPosition = -(this.currentIndex * 100)
    if (this.benefitsBar)
      this.benefitsBar.style.transform = `translateX(${newPosition}vw)`
  }

  handleTouchStart (e) {
    if (this.isMobileView()) {
      this.touchStartX = e.touches[0].clientX
      this.touchEndX = this.touchStartX // reset to avoid using old value
    }
  }

  handleTouchMove (e) {
    if (this.isMobileView()) {
      this.touchEndX = e.touches[0].clientX
    }
  }

  handleTouchEnd () {
    const swipeThreshold = 30
    const diff = this.touchEndX - this.touchStartX
    if (Math.abs(diff) > swipeThreshold) {
      if (diff < 0) {
        this.changeBenefit()
      } else {
        this.previousBenefit()
      }
    }
  }

  disconnectedCallback () {
    clearInterval(this.benefitsInterval)
    this.benefitsBar.removeEventListener(
      'touchstart',
      this.handleTouchStart,
    )
    this.benefitsBar.removeEventListener('touchmove', this.handleTouchMove)
    this.benefitsBar.removeEventListener('touchend', this.handleTouchEnd)
    window.removeEventListener('resize', this.handleResize.bind(this))
  }
}

customElements.define('benefits-bar', BenefitsBar)
